import React from 'react';
import { Button, Table } from 'react-bootstrap';

export function PendingLessonsTable({ lessons, onDelete, onSave, loading }) {
    if (lessons.length === 0) return null;
    return (
        <div>
            <div>
                <strong>Pending Lessons to Add:</strong>
            </div>
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Lesson Date</th>
                        <th>Time Slot</th>
                        <th>Location</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {lessons.map((lesson, index) => (
                        <tr key={index}>
                            <td>{lesson.date}</td>
                            <td>{lesson.slot}</td>
                            <td>{lesson.location}</td>
                            <td><Button variant="danger" onClick={() => onDelete(index)}>Delete</Button></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button onClick={onSave} disabled={loading} variant="primary">Save Lesson</Button>
        </div>
    );
}

export function ScheduledLessonsTable({ scheduledLessons, failedLessons, onDelete }) {
    return (
        <div>
            <div>
                <strong>Currently Scheduled Lessons</strong>
            </div>
            {scheduledLessons.length > 0 ?
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>Lesson Date</th>
                            <th>Time Slot</th>
                            <th>Location</th>
                            <th>Instructor</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scheduledLessons.map((lesson, index) => (
                            <tr key={index}>
                                <td>{lesson.date}</td>
                                <td>{lesson.slotName}</td>
                                <td>{lesson.location}</td>
                                <td>{lesson.instructor}</td>
                                <td><Button variant="danger" onClick={() => onDelete(index)}>Delete</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                : "No Lessons Scheduled"}
            <div>
                <strong>Lessons with Scheduling Issues</strong>
            </div>
            {failedLessons.length > 0 ?
                <div>
                    {failedLessons.map((lesson, index) => (
                        <div key={index}>{JSON.stringify(lesson)}</div>
                    ))}
                </div>
                : "No Issues During Scheduling"}
        </div>
    );
}
